import { Injectable, signal } from '@angular/core';

/**
 * Estado compartido: el backend rechazó un cumplimiento por falta de justificación tardía.
 *
 * El repositorio HTTP llama a {@link notificar} cuando recibe ese rechazo; el formulario de
 * cumplimiento observa {@link solicitud} y abre el modal de justificación. Así el modal se abre
 * sin que cada pantalla que guarda cumplimientos tenga que conocer ese caso.
 */
@Injectable({ providedIn: 'root' })
export class JustificacionTardiaRechazoStateService {
  private readonly _solicitud = signal(0);

  /** Contador que se incrementa con cada rechazo; solo importa que cambie. */
  readonly solicitud = this._solicitud.asReadonly();

  notificar(): void {
    this._solicitud.update((n) => n + 1);
  }
}
